import { EMPTY, of } from "rxjs";
import { filter, switchMap } from "rxjs/operators";
import { selectActiveTutorialConfig, selectIsTutorialActive, } from "../../../selectors/selectTutorial";
import { TypeActionModal } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionTutorialSelect } from "../actionTutorial";
export var epicTutorialOnCloseLevelUpScreen = function (action$, state$, deps) {
    return action$.pipe(filter(function (action) {
        return (action.type === TypeActionModal.Close &&
            action.modalId === IdModal.LevelUp &&
            selectIsTutorialActive(state$.value));
    }), switchMap(function () {
        var tutorialConfig = selectActiveTutorialConfig(state$.value);
        return tutorialConfig && tutorialConfig.nextStep
            ? of(actionTutorialSelect(tutorialConfig.nextStep))
            : EMPTY;
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/epics/epicTutorialOnCloseLevelUpScreen.ts
// module id = 2482
// module chunks = 3